<div class="dropbox pointer"
  [class.error]="error"
  [class.dragging]="isDragging"
  [class.pointer-events-none]="disabled"
  [class.disabled]="disabled"
  (click)="hiddenInput.click()"
  (dragover)="handleDragOver($event)"
  (dragenter)="isDragging=true"
  (dragleave)="handleDragMove($event)"
  (drop)="handleDrop($event)">
  <input [id]="elementId" #hiddenInput type="file" [accept]="filterFileInput()" (change)="handleFileInput($event)">
  <div class="dropbox-guide">
    <span class="dropbox-guide-icon"
      *ngIf="!fileName"
      [class.error]="error"
      inlineSVG="../../../../../assets/icons/Content/icon-upload.svg"></span>
    <i *ngIf="fileName" class="fa-solid fa-file-circle-check text-40px text-fileupload-green"></i>
    <div class="dropbox-guide-text">
      <h3 *ngIf="!fileName" class="m-0">{{ 'COMMON.DRAG_FILES_HERE' | translate }}</h3>
      <h3 *ngIf="fileName && !disabled" class="m-0 text-16px">{{ 'COMMON.DRAG_TO_CHANGE' | translate }}</h3>
      <p *ngIf="!fileName" class="m-0">{{ 'COMMON.CLICK_TO_CHOOSE_FILE' | translate }}&nbsp;({{fileTypes}})</p>
      <p *ngIf="fileName" class="m-0 text-20px">{{ 'COMMON.FILE' | translate }} {{fileName}}</p>
    </div>
  </div>
</div>
<div *ngIf="fileName" class="d-flex flex-row align-items-center gap-12px mt-2">
  <app-icon-button *ngIf="useViewBtn && isPdf(fileName)" title="COMMON.PREVIEW_FILE" (click)="previewClicked()" extraClasses="text-primary" iconType="fa-regular" iconName="fa-eye" iconClass="text-primary" label="COMMON.PREVIEW_FILE" [small]="true"></app-icon-button>
  <app-icon-button *ngIf="useDownloadBtn" title="COMMON.DOWNLOAD_FILE" (click)="downloadClicked()" extraClasses="text-primary" iconType="fa-solid" iconName="fa-download" iconClass="text-primary" label="COMMON.DOWNLOAD_FILE" [small]="true"></app-icon-button>
  <app-icon-button *ngIf="useDeleteBtn" title="COMMON.DELETE_FILE" (click)="deleteClicked()" extraClasses="text-danger" iconType="fa-regular" iconName="fa-trash-can" iconClass="text-danger" label="COMMON.DELETE_FILE" [small]="true"></app-icon-button>
</div>
